import { PROJECT_NAME } from 'containers/App/constants';

const CONTAINER_NAME = 'CreditCard';

export const GET_CREDIT_CARDS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CREDIT_CARDS`;
export const GET_CREDIT_CARDS_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CREDIT_CARDS_SUCCESS`;
export const GET_CREDIT_CARDS_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CREDIT_CARDS_FAIL`;

export const CREATE_CREDIT_CARD = `${PROJECT_NAME}/${CONTAINER_NAME}/CREATE_CREDIT_CARD`;
export const CREATE_CREDIT_CARD_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/CREATE_CREDIT_CARD_SUCCESS`;
export const CREATE_CREDIT_CARD_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/CREATE_CREDIT_CARD_FAIL`;

export const GET_CREDIT_CARD = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CREDIT_CARD`;
export const GET_CREDIT_CARD_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CREDIT_CARD_SUCCESS`;
export const GET_CREDIT_CARD_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/GET_CREDIT_CARD_FAIL`;

export const UPDATE_CREDIT_CARD = `${PROJECT_NAME}/${CONTAINER_NAME}/UPDATE_CREDIT_CARD`;
export const UPDATE_CREDIT_CARD_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/UPDATE_CREDIT_CARD_SUCCESS`;
export const UPDATE_CREDIT_CARD_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/UPDATE_CREDIT_CARD_FAIL`;

export const DELETE_CREDIT_CARD = `${PROJECT_NAME}/${CONTAINER_NAME}/DELETE_CREDIT_CARD`;
export const DELETE_CREDIT_CARD_SUCCESS = `${PROJECT_NAME}/${CONTAINER_NAME}/DELETE_CREDIT_CARD_SUCCESS`;
export const DELETE_CREDIT_CARD_FAIL = `${PROJECT_NAME}/${CONTAINER_NAME}/DELETE_CREDIT_CARD_FAIL`;

export const CLEAR_CREDIT_CARD_DETAILS = `${PROJECT_NAME}/${CONTAINER_NAME}/CLEAR_CREDIT_CARD_DETAILS`;

export type CardType = 'amex' | 'diners' | 'visa' | 'mastercard' | 'jcb' | 'unionpay';

export const CARD_TYPES_REQUIRING_BIN: readonly CardType[] = [
  'visa',
  'mastercard',
  'jcb',
  'unionpay'
] as const;

export const BRAND_LABELS: Record<CardType, string> = {
  amex: 'AMEX',
  diners: 'Diners',
  visa: 'Visa',
  mastercard: 'Mastercard',
  jcb: 'JCB',
  unionpay: 'UnionPay'
};

export const BRAND_LABEL_KEYS = Object.keys(BRAND_LABELS) as CardType[];
